import React from "react";
import { Box } from "@mui/material";
import CommonButton from "../CommonButton";

const CommonModalFooter = ({
  activeStep,
  vendorStep,
  locationStep,
  isSubmitting,
  onCancelOrBack,
  onPrimary,
}) => (
  <Box
    sx={{
      background: "#FFFFFF",
      borderTop: "1px solid #EEEEEE",
      display: "flex",
      flexDirection: { xs: "column-reverse", sm: "row" },
      gap: 1.5,
      justifyContent: "flex-end",
      mx: { xs: -2, sm: -3 },
      px: { xs: 2, sm: 3 },
      py: activeStep === locationStep ? 1.3 : 2,
      position: "sticky",
      bottom: 0,
      zIndex: 2,
    }}
  >
    <CommonButton
      label={activeStep === vendorStep ? "Cancel" : "Close"}
      onClick={onCancelOrBack}
      disabled={isSubmitting}
      fitContent
      sx={{
        fontSize: "1.3rem",
        height: activeStep === locationStep ? "3.2rem" : "3.4rem",
        width: { xs: "100%", sm: "10rem" },
      }}
    />

    <CommonButton
      label={
        isSubmitting
          ? "Submitting..."
          : activeStep === vendorStep
            ? "Next"
            : "Submit"
      }
      onClick={onPrimary}
      disabled={isSubmitting}
      filledButton
      fitContent
      sx={{
        fontSize: "1.3rem",
        height: activeStep === locationStep ? "3.2rem" : "3.4rem",
        width: { xs: "100%", sm: "10rem" },
      }}
    />
  </Box>
);

export default CommonModalFooter;
